<template>
  <mf-card-container
    title="Distribuição da média de itens na cesta"
    description="Comparação da distribuição de itens na cesta entre clientes que receberam e não receberam a campanha no mesmo período nas mesmas lojas."
  >
    <mf-loading :width="4" :height="70" loader-type="table" :boolean-loader="loading">
      <v-data-table v-if="hasData" class="mt-3" :items="topMostBilledProducts" :headers="headers" hide-default-footer disable-pagination disable-sort>
        <template v-slot:header.basket="{ header }">
          <div class="avg-basket-header">
            <span class="cinza-d20-text">{{ header.text }}</span>
          </div>
        </template>

        <template v-slot:header.didNotReceive="{ header }">
          <div class="avg-basket-header">
            <span class="cinza-d20-text">Clientes</span>
            <span class="cinza-l10-text">{{ header.text }}</span>
          </div>
        </template>

        <template v-slot:header.received="{ header }">
          <div class="avg-basket-header">
            <span class="cinza-d20-text">Clientes</span>
            <span class="cinza-l10-text">{{ header.text }}</span>
          </div>
        </template>

        <template v-slot:item.didNotReceive="{ item }">
          <span>{{ item.didNotReceive | localeString }}</span> |
          <mf-tooltip right max-width="350px" variant="secondary">
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <span class="percentageColor">{{ item.didNotReceivedPercentage | localeString(2) }}%</span>
              </span>
            </template>
            <span>Porcentagem do total de consumidores que compraram no período e não receberam disparo desta campanha.</span>
          </mf-tooltip>
        </template>

        <template v-slot:item.received="{ item }">
          <div class="d-flex flex-row" style="gap: 4px">
            {{ item.received.toLocaleString('pt-BR') }} |
            <mf-tooltip right max-width="350px" variant="secondary">
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <span class="percentageColor">{{ item.receivedPercentage | localeString(2) }}%</span>
                </span>
              </template>
              <span>Porcentagem do total de cupons realizados no período da campanha por consumidores que receberam disparos.</span>
            </mf-tooltip>
            <mf-stonks variant="percentage" :percentage="item.dif" bold />
          </div>
        </template>
      </v-data-table>
      <empty-chart v-else paddingTop="106px" />
    </mf-loading>
  </mf-card-container>
</template>

<script>
import EmptyChart from '@/modules/mobile/desempenho/views/components/EmptyChart'

export default {
  name: 'AverageBasketItems',
  components: {
    EmptyChart,
    MfStonks: () => import('@/modules/maria/campanha-da-maria-v2/views/components/Results/MfStonks.vue'),
  },
  props: {
    dataCard: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    hasData() {
      if (!this.topMostBilledProducts) return false
      if (!this.topMostBilledProducts.length) return false
      return (
        this.topMostBilledProducts.reduce((total, valor) => total + valor.received, 0) +
        this.topMostBilledProducts.reduce((total, valor) => total + valor.didNotReceive, 0)
      )
    },
    topMostBilledProducts() {
      if (!this.dataCard.length) return []

      const labels = ['0 - 10', '11 - 30', '31 - 60', '61 - 90', '+91']

      return this.dataCard.map((el, index) => {
        return {
          basket: labels[index],
          received: el.received_and_bought_clients,
          didNotReceive: el.not_received_and_bought_clients,
          receivedPercentage: this.percentage('received')[index],
          didNotReceivedPercentage: this.percentage('notReceived')[index],
          dif: this.difPercentage('received', 'notReceived')[index],
        }
      })
    },
    headers() {
      return [
        {
          text: 'Itens na cesta',
          value: 'basket',
          width: '25%',
        },
        {
          text: 'Não receberam',
          value: 'didNotReceive',
        },
        {
          text: 'Receberam',
          value: 'received',
        },
      ]
    },
  },
  methods: {
    percentage(type) {
      let listOfDataCard = []
      let listOfPercentage = []
      if (type === 'received') {
        this.dataCard.forEach(function (item) {
          listOfDataCard.push(item.received_and_bought_clients)
        })
        const total = listOfDataCard.reduce((total, valor) => total + valor)

        this.dataCard.forEach(function (item) {
          let receivedValue = (item.received_and_bought_clients / total) * 100
          listOfPercentage.push(isNaN(receivedValue) ? 0 : receivedValue)
        })
      } else {
        this.dataCard.forEach(function (item) {
          listOfDataCard.push(item.not_received_and_bought_clients)
        })
        const total = listOfDataCard.reduce((total, valor) => total + valor)

        this.dataCard.forEach(function (item) {
          let notReceivedValue = (item.not_received_and_bought_clients / total) * 100
          listOfPercentage.push(isNaN(notReceivedValue) ? 0 : notReceivedValue)
        })
      }
      return listOfPercentage
    },
    difPercentage(typeRecieves, typeNotRecieves) {
      let listOfDif = []
      const received = this.percentage(typeRecieves)
      const notReceived = this.percentage(typeNotRecieves)
      for (let i = 0; i < received.length; i++) {
        listOfDif.push(received[i] - notReceived[i])
      }
      return listOfDif
    },
  },
}
</script>
<style lang="scss">
.help-icon {
  line-height: 0.1;
  margin-left: 4px;
}

.percentageColor {
  color: $marca-1;
  font-weight: bold;
}

.cinza-d20-text {
  color: $cinza-d20;
}

.cinza-l10-text {
  color: $cinza-l10;
}

.avg-basket-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: bold;
  font-size: 14px;
}
</style>
